import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { X, Sparkles } from "lucide-react";

const STORAGE_KEY = "hearinsight_popups_seen";

export default function MarketingPopup() {
  const [popup, setPopup] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/marketing/popups");
        if (!data || data.length === 0) return;
        const seen = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
        const sessionSeen = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
        const candidate = data.find(p => {
          if (p.display_frequency === "always") return true;
          if (p.display_frequency === "per_session") return !sessionSeen[p.id];
          return !seen[p.id]; // once
        });
        if (candidate) {
          setPopup(candidate);
          setOpen(true);
          if (candidate.display_frequency === "once") {
            seen[candidate.id] = Date.now();
            localStorage.setItem(STORAGE_KEY, JSON.stringify(seen));
          } else if (candidate.display_frequency === "per_session") {
            sessionSeen[candidate.id] = Date.now();
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(sessionSeen));
          }
        }
      } catch {}
    }, 2500);
    return () => clearTimeout(t);
  }, []);

  if (!popup || !open) return null;

  const close = () => setOpen(false);
  const cta = () => {
    if (popup.cta_link) {
      close();
      if (popup.cta_link.startsWith("http")) window.open(popup.cta_link, "_blank");
      else navigate(popup.cta_link);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-fade-in-up" data-testid="marketing-popup">
      <div className="bg-white rounded-3xl max-w-md w-full overflow-hidden relative shadow-2xl">
        <button onClick={close} className="absolute top-4 right-4 z-10 w-8 h-8 rounded-full bg-white/90 hover:bg-white flex items-center justify-center text-[#1A1728]" data-testid="popup-close">
          <X className="w-4 h-4" />
        </button>
        {popup.image && <img src={popup.image} alt={popup.title} className="w-full h-48 object-cover" />}
        <div className="p-8 text-center">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#6B4BA3] to-[#9D84D2] flex items-center justify-center mx-auto mb-4">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <h2 className="font-serif text-3xl text-[#1A1728] mb-3 leading-tight">{popup.title}</h2>
          <div className="text-[#5C5870] leading-relaxed mb-6" dangerouslySetInnerHTML={{ __html: popup.content }} />
          {popup.cta_text && popup.cta_link && (
            <button onClick={cta} className="lumina-btn-primary w-full" data-testid="popup-cta">{popup.cta_text}</button>
          )}
        </div>
      </div>
    </div>
  );
}
